import { render, staticRenderFns } from "./FeedbackEvent.vue?vue&type=template&id=190edd8c&scoped=true"
import script from "./FeedbackEvent.vue?vue&type=script&lang=js"
export * from "./FeedbackEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190edd8c",
  null
  
)

export default component.exports